import loginDialog from './loginDialog.vue'
export default loginDialog